import { urls as solitaireUrls } from 'invaluable-solitaire';

export const getAuctionLotUrl = (lotTitle, lotNumber, lotRef) => `${solitaireUrls.seoFriendlyUrl(lotTitle)}-${solitaireUrls.seoFriendlyUrl(lotNumber)}-c-${solitaireUrls.seoFriendlyUrl(lotRef)}`;
